var _path, _g, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInhibitor = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 34 33",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#inhibitor_svg__a)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "inhibitor_svg__b",
  style: {
    maskType: "luminance"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 34,
  height: 33
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M33.97.95H0v32h33.97v-32Z",
  fill: "#fff"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#inhibitor_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "m17.62 32.67 4.13-4.47a.88.88 0 0 0 .23-.45 1 1 0 0 0-.06-.49 1.001 1.001 0 0 0-.33-.39.9.9 0 0 0-.48-.14h-8.26a.9.9 0 0 0-.48.14.94.94 0 0 0-.32.39.82.82 0 0 0-.06.49.8.8 0 0 0 .22.45l4.13 4.47c.081.09.18.161.29.21a.908.908 0 0 0 .7 0 .86.86 0 0 0 .29-.21Z"
}))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m29.58 0 3.4 3.31L4.39 31.03l-3.41-3.3L29.58 0Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M29.79 8.42 28.31 9.9l3.32 5.75-7.33 12.69h-1.27l-1.72 2.02h4.16l8.5-14.71-4.18-7.23ZM5.71 21.5l-3.38-5.85L9.66 2.97h14.57l1.53-1.53-.29-.49H8.49L0 15.65l4.23 7.33 1.48-1.48ZM9.87 28.34l-1.62 1.61.24.41h4.16l-1.71-2.02H9.87ZM15.11 23.07h6.16l4.28-7.42-1.1-1.91-9.34 9.33Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.95 8.23H12.7l-4.28 7.42 1.13 1.98 9.4-9.4Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "inhibitor_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h33.97v32.95H0z"
})))));
export default SvgInhibitor;